import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { SkapaColors, SkapaTokens } from '@inter-ikea-guida/skapa';
import { KOMPIS_HEADER_HEIGHT, SIDEBAR_WIDTH } from '../../utils/constants';
const StyledSidebarAside = styled.aside `
  padding: 0 ${SkapaTokens.space150};
  order: 2;
  position: relative;
  height: calc(100vh - ${KOMPIS_HEADER_HEIGHT});
  width: ${SIDEBAR_WIDTH}px;
  overflow: ${props => (props.$showOnboarding ? 'hidden' : 'auto')};
  scrollbar-gutter: ${props => (props.$showOnboarding ? 'unset' : 'stable')};
  background-color: ${SkapaColors.colourNeutral1};
`;
export const Sidebar = ({ children, onboarding }) => {
    return (_jsx(StyledSidebarAside, { id: 'guide-sidebar', "data-testid": 'guide-sidebar', "$showOnboarding": !!onboarding, children: onboarding || children }));
};
//# sourceMappingURL=Sidebar.js.map